import React from 'react'
import { useTranslation } from 'react-i18next'
import Loading from '../Loading'

const TokenForm = ({ token, setToken, onSubmit, onBack, onRepeatRequest, isLoading, errorMessage }) => {
    const { t } = useTranslation()

    const handleSubmit = (e) => {
        e.preventDefault()
        onSubmit(token)
    }

    return (
        <div className="">
            <div className="modal-title">
                <p className="text-3xl text-white text-left font-bold">{t('verifyYourEmail')}</p>
            </div>
            <div className="text-sm text-deselectPurple text-left mt-2">
                <p>{t('weHaveSentYouALinkToGetBackIntoYourAccountAndCheckYourMailAndCopyYourTokenHere')}</p>
            </div>

            <div className="sign-up-section">
                <div className="">
                    <form onSubmit={handleSubmit}>
                        <div className="my-5">
                            <span className="text-white text-lg font-semibold text-left flex justify-start">{t('token')}</span>
                            <input
                                id="token-input"
                                className="w-full text-white border border-b-deselectPurple py-3 border-x-0 border-t-0"
                                placeholder={t('token')}
                                style={{ backgroundColor: 'transparent' }}
                                value={token}
                                onChange={(e) => setToken(e.target.value)}
                            />
                        </div>
                        <div className="error-message">{errorMessage}</div>
                        <div className="login-form-element-holder px-6 py-3">
                            <button
                                className={`bg-highlightColor text-deepPurple py-3 text-lg font-semibold rounded-full w-full h-[50px] ${
                                    !isLoading ? 'hover:bg-darkPurple hover:text-white' : ''
                                } duration-[250ms] ease-in-out transition-all flex items-center justify-center`}
                                disabled={isLoading}
                            >
                                {isLoading ? <Loading primaryColor="#413F5E" /> : t('submit')}
                            </button>
                        </div>
                    </form>
                </div>
                <div>
                    <p className="login-missing-text">
                        <span className="login-missing-text-q">{t('didntGetAMail')}</span>
                        <span className="login-missing-text-action" id="resend-request" onClick={onRepeatRequest}>
                            {t('resendARequest')}
                        </span>
                    </p>
                    {onBack && (
                        <p className="login-missing-text">
                            <span className="login-missing-text-action" onClick={onBack}>
                                {t('backToForgotPassword')}
                            </span>
                        </p>
                    )}
                </div>
            </div>
        </div>
    )
}

export default TokenForm
